export default __webpack_public_path__ + "static/media/ocx-allocated-bg.c54818e5.svg";